var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('StripePayment',{attrs:{"amount":100},on:{"payment-success":_vm.handlePaymentSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }